import { EP } from "../configs/constant";
import { getPath } from "../helpers/handleUrl";
import { IProductDetailResponse, IProductResponse } from "../types/product";
import axiosService, { AxiosService } from "./axiosService";
class ProductService {
    readonly service: AxiosService;
    constructor() {
        this.service = axiosService;
    }
    getProducts() {
        return this.service.get<IProductResponse>(getPath(EP.PRODUCT, EP.LIST))
    }
    getProduct(slug?: string) {
        return this.service.get<IProductDetailResponse>(getPath(EP.PRODUCT, EP.DETAIL, {
            query: {
                [EP.SLUG]: slug
            }
        }))
    }
}
const productService = new ProductService();
export default productService;